// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
import {getAuth} from'firebase/auth';
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDZ9AOMCrxFHqxbx65Zj4N8roiDdznQSz0",
  authDomain: "tablitas-fad46.firebaseapp.com",
  projectId: "tablitas-fad46",
  storageBucket: "tablitas-fad46.appspot.com",
  messagingSenderId: "1025320562956",
  appId: "1:1025320562956:web:b06ab40b01fce18ae15929"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app)
export const db = getFirestore(app);
